export default __webpack_public_path__ + "static/media/honor-swiper-04.08354ec2.jpg";